import { PROTECTED_ROUTE } from '@/shared/constants/sidebar-config';
import { useSessionStore } from '../model/store';
import { hasPermission } from './rbac';

const SUPER_ADMIN_ALLOWED_ROUTES: PROTECTED_ROUTE[] = [
  PROTECTED_ROUTE.SETTINGS,
  PROTECTED_ROUTE.INVITE_ADMIN,
  PROTECTED_ROUTE.MARKET_FACILITIES,
  PROTECTED_ROUTE.LOGIN_ACTIVITY,
  PROTECTED_ROUTE.STAFF_USAGE,
  PROTECTED_ROUTE.CHANGELOG,
];

export const getRbacRoute = (
  route: PROTECTED_ROUTE
): { allowed: boolean; nextRoute?: string } => {
  const isSuperAdmin = useSessionStore.getState().isSuperAdmin;
  const isContractor = useSessionStore.getState().isContractor;
  const isUserOrganizationCreator =
    useSessionStore.getState().user?.isOrganizationCreator;

  if (route === PROTECTED_ROUTE.INVITE_REGULAR_USER) {
    if (
      isSuperAdmin ||
      (!hasPermission(['USER_CREATE']) && !isUserOrganizationCreator)
    ) {
      return { allowed: false, nextRoute: PROTECTED_ROUTE.SETTINGS };
    }
  }

  if (route === PROTECTED_ROUTE.INVITE_ADMIN) {
    if (!isSuperAdmin) {
      return { allowed: false, nextRoute: PROTECTED_ROUTE.SETTINGS };
    }
  }

  if (route === PROTECTED_ROUTE.MARKET_FACILITIES) {
    if (!(isSuperAdmin || isContractor)) {
      return { allowed: false, nextRoute: PROTECTED_ROUTE.FACILITIES };
    }
  }

  if (route === PROTECTED_ROUTE.MARKET_INTEL) {
    if (
      !isUserOrganizationCreator &&
      !hasPermission(['MARKET_INTELLIGENCE_VIEW'])
    ) {
      return { allowed: false, nextRoute: PROTECTED_ROUTE.FACILITIES };
    }
  }

  if (route === PROTECTED_ROUTE.LOGIN_ACTIVITY) {
    if (!isSuperAdmin && !hasPermission(['USER_LIST_VIEW'])) {
      return { allowed: false, nextRoute: PROTECTED_ROUTE.FACILITIES };
    }
  }

  if (route === PROTECTED_ROUTE.STAFF_USAGE) {
    if (!isSuperAdmin && !hasPermission(['USER_ANALYTICS_VIEW'])) {
      return { allowed: false, nextRoute: PROTECTED_ROUTE.FACILITIES };
    }
  }

  if (route === PROTECTED_ROUTE.CHANGELOG) {
    if (!isSuperAdmin) {
      return { allowed: false, nextRoute: PROTECTED_ROUTE.FACILITIES };
    }
  }

  if (isSuperAdmin === false) {
    return { allowed: true, nextRoute: PROTECTED_ROUTE.FACILITIES };
  }

  if (SUPER_ADMIN_ALLOWED_ROUTES.includes(route)) {
    return { allowed: true };
  } else {
    return { allowed: false, nextRoute: PROTECTED_ROUTE.MARKET_FACILITIES };
  }
};
